import { BehaviorSubject, Observable, ReplaySubject, Subject, zip } from "rxjs";
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup
} from "@angular/forms";
import { map, startWith } from "rxjs/operators";

import { Funcao } from "../../models/funcao";
import { FuncaoFacade } from "../../funcao.facade";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";

@Component({
  selector: "app-funcao-selecao",
  templateUrl: "./funcao-selecao.component.html",
  styleUrls: ["./funcao-selecao.component.scss"]
})
export class FuncaoSelecaoComponent implements OnInit, OnDestroy {
  @Input() readonly = false;

  public form: FormGroup;

  public categorias$: Observable<string[]>;

  public funcoes$: Observable<Funcao[]>;
  public funcoesFiltradasNaoAdicionadas$: Observable<Funcao[]>;
  public funcoesAdicionadas$: Observable<Funcao[]>;

  @ViewChild('funcaoSelecaoInputFuncao') inputFuncao: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private funcaoFacade: FuncaoFacade
  ) {
    this.categorias$ = this.funcaoFacade.getCategorias$();

    this.funcoes$ = this.funcaoFacade.getFuncoes$();
    this.funcoesFiltradasNaoAdicionadas$ = this.funcaoFacade.getFuncoesFiltradasNaoAdicionadas$();
    this.funcoesAdicionadas$ = this.funcaoFacade.getFuncoesAdicionadas$();
  }

  public ngOnInit(): void {
    this.createForm();
  }

  public ngOnDestroy(): void {
    this.funcaoFacade.destroy();
  }

  private setFocus() {
    this.inputFuncao?.nativeElement?.focus();
  }

  public selecionarFuncao($event: MatAutocompleteSelectedEvent): void {
    const funcaoSelecionada = this.funcaoFacade.getFuncaoFiltradaByNome($event.option.value);
    this.funcaoFacade.setFuncaoSelecionada(funcaoSelecionada);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      categoria: new FormControl({
        value: '',
        disabled: this.readonly,
      }),
      funcao: new FormControl(
        { value: '', disabled: this.readonly }
      ),
    });

    const funcaoControl = this.form.get("funcao") as FormControl;
    const categoriaControl = this.form.get("categoria") as FormControl;

    categoriaControl.valueChanges
      .pipe(
        startWith('')
      )
      .subscribe(categoria => {
        funcaoControl.reset();
        this.funcaoFacade.buscarFuncoes(categoria);
      });

    funcaoControl.valueChanges
      .pipe(
        startWith(''),
        map(input => this.funcaoFacade.filtrarFuncoes(input))
      ).subscribe();

    this.funcoesAdicionadas$.subscribe(_ => {
      funcaoControl.reset();
      this.setFocus();
    })
  }

  compareEnumCategoria(object1: any, object2: any) {
    return object1 === object2;
  }
}
